import React from "react"
import { Box, Typography, Button } from "@material-ui/core"

import { useStaticQuery, graphql } from "gatsby"
import WhatsAppIcon from "@material-ui/icons/WhatsApp"
const Info = () => {
  const data = useStaticQuery(graphql`
    query Info {
      sanityCompanyInfo {
        city
        country
        email
        name
        phone
        address
      }
      sanitySetting {
        logo {
          asset {
            url
          }
        }
        whatsapp {
          message
          phone
        }
      }
    }
  `)
  const info = data.sanityCompanyInfo
  const logo = data.sanitySetting.logo.asset.url
  const { phone, message } = data.sanitySetting.whatsapp
  const messageWhatsapp = message
    ? message.replace(/ /g, "%20").replace(/_/g, "%0A")
    : `Hola ${info.name}, vengo de su sitio web`
  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      flexDirection="column"
      style={{ maxWidth: 350 }}
    >
      <img width="100" src={logo}></img>
      <Typography variant="h3">{info.name}</Typography>

      <Typography variant="caption" gutterBottom>
        {info.description}
      </Typography>
      <Box>
        <Typography>
          {info.country}-{info.city}
        </Typography>
        <Typography>Dirección: {info.address}</Typography>
        <Typography>email: {info.email}</Typography>
      </Box>
      <Button
        style={{ background: "#25d366", color: "#ece5dd" }}
        fullWidth
        color="primary"
        variant="contained"
        component="a"
        target="_blank"
        href={`https://api.whatsapp.com/send?phone=${phone}&text=${messageWhatsapp}`}
      >
        <WhatsAppIcon />
        WhatsApp
      </Button>
    </Box>
  )
}

export default Info
